import Api from './api';

const LrfService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/lrf/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/lrf/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    numLrf: async (params) => {
        return Api({
            method: 'get',
            url: '/restrito/lrf/numlrf',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    deletar: (id) => {
        Api.delete(`/restrito/lrf/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    lrfEdit: async (id) => {
        const response = await Api.get(`/restrito/lrf/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/lrf/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/lrf/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default LrfService;